import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTenants, selectUserState } from "../store/user/selectors";
import { getTenants } from "../store/user/thunks";

export const useTenants = (fetch = false) => {
  const dispatch = useDispatch();
  const tenants = useSelector(selectTenants);
  const { tenantsLoading: loading, selectedTenantId } =
    useSelector(selectUserState);

  useEffect(() => {
    if (!tenants?.length && fetch) {
      dispatch(getTenants());
    }
  }, [fetch]);

  const tenantOptions = useMemo(
    () =>
      tenants.map((t) => ({
        label: t?.name,
        value: t?.id,
      })),
    [tenants],
  );

  return { tenants, tenantOptions, loading, selectedTenantId };
};
